const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

const twoDigitsToWords = (num: number): string => {
  if (num < 20) return ONES[num];
  const tens = Math.floor(num / 10);
  const ones = num % 10;
  return `${TENS[tens]}${ones ? " " + ONES[ones] : ""}`;
};

const threeDigitsToWords = (num: number): string => {
  const hundreds = Math.floor(num / 100);
  const rest = num % 100;
  if (hundreds && rest) return `${ONES[hundreds]} Hundred And ${twoDigitsToWords(rest)}`;
  if (hundreds) return `${ONES[hundreds]} Hundred`;
  return twoDigitsToWords(rest);
};

/** Converts a whole number into words using the Indian numbering system
 *  (Lakh/Crore) — e.g. 445000 -> "Four Lakh Forty-Five Thousand" */
const wholeNumberToWords = (num: number): string => {
  if (num === 0) return "Zero";

  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const remainder = num % 1000;

  const parts: string[] = [];
  if (crore) parts.push(`${threeDigitsToWords(crore)} Crore`);
  if (lakh) parts.push(`${twoDigitsToWords(lakh)} Lakh`);
  if (thousand) parts.push(`${twoDigitsToWords(thousand)} Thousand`);
  if (remainder) parts.push(threeDigitsToWords(remainder));

  return parts.join(" ");
};

/** Converts a rupee amount into words for invoice printing, e.g.
 *  4490 -> "Four Thousand Four Hundred And Ninety Rupees Only" */
export const amountInWords = (amount: number): string => {
  const rounded = Math.round((amount + Number.EPSILON) * 100) / 100;
  const rupees = Math.floor(rounded);
  const paise = Math.round((rounded - rupees) * 100);

  const rupeeWords = wholeNumberToWords(rupees);

  if (!paise) {
    return `${rupeeWords} Rupees Only`;
  }

  const paiseWords = twoDigitsToWords(paise);
  return `${rupeeWords} Rupees And ${paiseWords} Paise Only`;
};
